import axios from 'axios'
// 封装ajax回调
export const ajaxAPI = (method, url, data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      data: data
    }).then((response) => {
      // 当token失效的时候跳转登陆页面
      if (response.data.status === 400) {
        console.log('response', response)
        var source = window.sessionStorage.getItem('source')
        console.log('source', source)
        if (source) {
          window.location.href = source
        } else {
          window.location.href = '/'
        }
      } else {
        resolve(response)
      }
    }).catch((error) => {
      console.log(error)
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/ajaxUtil.js